import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresListaNoremunerados', {
    template: template,
    controller: NominasNominaColaboradoresListaNoremuneradosComponent,
    bindings: {
      filtro: '<',
      data: '<',
    },
  })

function NominasNominaColaboradoresListaNoremuneradosComponent($filter) {
  let $ctrl = this,
    filterBy = $filter('filter')

  $ctrl.$onChanges = $onChanges
  $ctrl.filtrar = filtrar
  $ctrl.editando = null

  function $onChanges(changes) {
    if (changes.filtro || changes.data) {
      filtrar()
    }
  }

  function filtrar() {
    $ctrl.resultados = filterBy($ctrl.data, $ctrl.filtro)
    $ctrl.ocultos = $ctrl.data.length - $ctrl.resultados.length
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/noremunerados/component.js